import * as React from 'react';

import cx from 'classnames';

export interface ILabeledButtonProps {
    onClick?: (e: React.MouseEvent<HTMLElement>) => void;
    text?: string;
    componentClasses?: string;
    img?: string;
    disabled?: boolean;
    alt?: string;
    label?: string;
    roundCorners?: boolean;
}
export const LabeledButton: React.FC<ILabeledButtonProps> = ({
    onClick,
    text,
    componentClasses,
    img,
    disabled,
    alt,
    label,
    roundCorners
}) => {
    return (
        <div
            className={cx(`button`, `labeled-btn`, componentClasses, {
                [`disabled`]: disabled,
                ['round-corners']: roundCorners
            })}
            onClick={onClick}
        >
            {label ? (
                <div className={`label-comp`}>{label}</div>
            ) : (
                <div className={`btn-label`}>{img && <img alt={alt} src={img} />}</div>
            )}
            <div className={`btn-body`}>{text}</div>
        </div>
    );
};
